module.exports = __webpack_public_path__ + "assets/img/sqjk.257b4cdd.png";